import { useIntegrationName } from "../useIntegrationName";
export var useScopedEventName = function (eventName) {
    var integrationName = useIntegrationName();
    return integrationName + "-" + eventName;
};
